import { Link } from "react-router-dom";
import { FaArrowRight, FaUserFriends, FaSuitcase, FaHeart, FaShoppingCart, FaRegHeart, FaCalendarAlt } from "react-icons/fa";
import StarRating from "./StarRating";
import { useShop } from "../../context/ShopContext";
import { BOOKING_URL } from "../../data/config";
import "./common.css";

export function ServiceCard({ service }) {
  const Icon = service.icon;
  return (
    <div className="service-card card">
      <div className="service-img">
        <img src={service.image} alt={service.title} loading="lazy" />
        <span className="service-icon">{Icon && <Icon />}</span>
      </div>
      <div className="service-body">
        <h3>{service.title}</h3>
        <p>{service.short}</p>
        <Link to={`/services/${service.id}`} className="read-more">
          Read More <FaArrowRight />
        </Link>
      </div>
    </div>
  );
}

export function TaxiCard({ taxi }) {
  return (
    <div className="taxi-card card">
      <div className="taxi-img">
        <img src={taxi.image} alt={taxi.title} loading="lazy" />
      </div>
      <div className="taxi-body">
        <h3>{taxi.title}</h3>
        <p>{taxi.desc}</p>
        <div className="taxi-meta">
          <span><FaUserFriends /> {taxi.seats} Passengers</span>
          <span><FaSuitcase /> {taxi.luggage} Bags</span>
        </div>
        <div className="taxi-actions">
          <Link to={`/taxis/${taxi.id}`} className="btn btn-outline">Details</Link>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Book online Now</a>
        </div>
      </div>
    </div>
  );
}

export function TeamCard({ member }) {
  return (
    <Link to={`/team/${member.id}`} className="team-card card">
      <div className="team-img">
        <img src={member.image} alt={member.name} loading="lazy" />
      </div>
      <div className="team-body">
        <h3>{member.name}</h3>
        <span className="team-role">{member.role}</span>
      </div>
    </Link>
  );
}

export function BlogCard({ post }) {
  return (
    <article className="blog-card card">
      <Link to={`/blogs/${post.id}`} className="blog-img">
        <img src={post.image} alt={post.title} loading="lazy" />
        <span className="blog-cat">{post.category}</span>
      </Link>
      <div className="blog-body">
        <div className="blog-meta">
          <span><FaCalendarAlt /> {post.date}</span>
          <span>By {post.author}</span>
        </div>
        <h3><Link to={`/blogs/${post.id}`}>{post.title}</Link></h3>
        <p>{post.excerpt}</p>
        <Link to={`/blogs/${post.id}`} className="read-more">
          Read More <FaArrowRight />
        </Link>
      </div>
    </article>
  );
}

export function ProductCard({ product, list }) {
  const { addToCart, toggleWishlist, inWishlist } = useShop();
  return (
    <div className={`product-card card ${list ? "list" : ""}`}>
      <div className="product-img">
        <Link to={`/shop/${product.id}`}>
          <img src={product.image} alt={product.name} loading="lazy" />
        </Link>
        {product.tag && <span className="product-tag">{product.tag}</span>}
        <button
          className={`wish-btn ${inWishlist(product.id) ? "active" : ""}`}
          onClick={() => toggleWishlist(product)}
          aria-label="Add to wishlist"
        >
          {inWishlist(product.id) ? <FaHeart /> : <FaRegHeart />}
        </button>
      </div>
      <div className="product-body">
        <span className="product-cat">{product.category}</span>
        <h3><Link to={`/shop/${product.id}`}>{product.name}</Link></h3>
        <StarRating rating={product.rating} />
        {list && <p className="product-desc">{product.desc}</p>}
        <div className="product-price">
          <span className="now">${product.price.toFixed(2)}</span>
          {product.oldPrice && <span className="old">${product.oldPrice.toFixed(2)}</span>}
        </div>
        <button className="btn btn-primary btn-block" onClick={() => addToCart(product)}>
          <FaShoppingCart /> Add to Cart
        </button>
      </div>
    </div>
  );
}
